import { useState, useEffect } from 'react';
import { loadDynamicCSS } from '../services/css/dynamicLoader';

/**
 * Hook to load dynamic CSS from server
 * @param {string} url - Optional custom URL to load CSS from
 * @returns {Object} { loaded, error, reload }
 */
const useDynamicCSS = (url) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  const loadCSS = async () => {
    try {
      setLoaded(false);
      setError(null);
      const success = await loadDynamicCSS(url);
      setLoaded(true);
      if (!success) {
        setError(new Error('Failed to load CSS, using fallback'));
      }
    } catch (err) {
      setError(err);
      setLoaded(true); // Still set loaded to true so app can continue
    }
  };

  useEffect(() => {
    loadCSS();
  }, [url]);

  const reload = () => {
    loadCSS();
  };

  return { loaded, error, reload };
};

export default useDynamicCSS;
